import * as PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './InputError.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const cln = classnames.bind(styles);
function InputError({
  children = '',
  className,
  hideWhenEmpty = false,
  ...rest
}) {
  if (!children && hideWhenEmpty) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    className: cln('InputError', className),
    ...rest,
    children: children
  });
}
InputError.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  hideWhenEmpty: PropTypes.bool
};
export default InputError;